import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Compass, Target, Layers, MapPin, ListOrdered } from "lucide-react";

const deliverables = [
  { icon: Target, text: "qué percepción construir" },
  { icon: Compass, text: "qué posicionamiento ocupar" },
  { icon: Layers, text: "qué activos fortalecer" },
  { icon: MapPin, text: "dónde intervenir" },
  { icon: ListOrdered, text: "en qué orden" },
];

const Pricing = () => {
  const scrollToCalendly = () => {
    const calendlySection = document.getElementById("calendly");
    if (calendlySection) {
      calendlySection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return <section className="py-24 md:py-32 relative overflow-hidden bg-foreground text-background" id="inversion">
      <div className="absolute inset-0 bg-gradient-to-b from-neutral-900 to-black opacity-50" />
      
      <div className="container px-4 relative z-10">
        {/* Section header */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white">
            CORESSEN <span className="text-gradient-gold italic">CAPITAL</span>®
          </h2>
          <p className="text-primary text-sm font-semibold tracking-widest uppercase">
            Dirección Estratégica de Capital de Marca
          </p>
        </motion.div>

        {/* Gradient line */}
        <motion.div initial={{
        scaleX: 0
      }} whileInView={{
        scaleX: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.3
      }} className="h-1 bg-gradient-to-r from-primary via-primary to-transparent max-w-4xl mx-auto mb-16 rounded-full" />

        {/* Content card */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="max-w-4xl mx-auto">
          <div className="bg-neutral-900/80 backdrop-blur-sm rounded-3xl p-8 md:p-12 relative overflow-hidden border border-neutral-700/50">
            {/* Glow effect */}
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-transparent" />
            
            <div className="relative z-10 text-center">
              <p className="text-lg md:text-xl text-neutral-300 leading-relaxed mb-10 max-w-3xl mx-auto">
                En 60/90 días identificamos la brecha entre el valor que tu empresa tiene y el que está logrando hacer perceptible, y definimos qué necesita construir, elevar o transferir.
              </p>

              <p className="text-white font-medium text-lg mb-6">
                Te llevás una dirección clara sobre:
              </p>

              {/* Deliverables grid */}
              <div className="grid md:grid-cols-5 gap-4 mb-10">
                {deliverables.map((item, index) => (
                  <motion.div
                    key={item.text}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.3 + index * 0.1 }}
                    className="bg-neutral-800/50 rounded-xl p-5 border border-neutral-700/50"
                  >
                    <item.icon className="w-6 h-6 text-primary mx-auto mb-3" />
                    <p className="text-sm text-neutral-300 leading-tight">{item.text}</p>
                  </motion.div>
                ))}
              </div>

              <p className="text-neutral-400 text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
                Para dejar de invertir en acciones aisladas y empezar a gobernar tu marca como un activo estratégico.
              </p>

              {/* CTA */}
              <Button variant="gold" size="xl" onClick={scrollToCalendly} className="tracking-wider font-semibold rounded-full">
                AGENDAR UNA CONVERSACIÓN
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};
export default Pricing;
